import _ from 'lodash';

export const getHqDepart = (dps) => {
  return _.filter(
    dps,
    (dp) =>
      dp.Level === '1' &&
      (dp.name === '기술지원본부' ||
        dp.name === '전략사업본부' ||
        dp.name === 'SI사업본부'),
  );
};
